import FilterField from "@/views/Properties/components/Filters/components/FiltersList/components/Field";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import { FILTERS_LIST, USER_TAGS } from "../../../gql/UserProfileQueries";

export default {
  name: "user_preferences_control",

  props: {
    preferences: Array
  },

  data() {
    return {
      allPreferences: [],
      isShowAllPreferences: false,

      myPreferencesLoading: false,

      filters: [],
      isShowFilters: false
    };
  },

  apollo: {
    filters: {
      query: FILTERS_LIST
    }
  },

  computed: {
    slicedAllPreferences() {
      if (this.isShowAllPreferences) {
        return this.allPreferences;
      } else {
        return this.allPreferences ? this.allPreferences.slice(0, 7) : [];
      }
    },

    filtersList() {
      if (this.filters) {
        return this.filters.entities;
      }
    },
    cacheFilters() {
      if (localStorage.getItem("searchParams")) {
        return JSON.parse(localStorage.getItem("searchParams"));
      } else {
        return { filters: [] };
      }
    }
  },

  mounted: function() {
    if (this.cacheFilters && this.cacheFilters.filters.length) {
      this.getMyPreferences();
    } else {
      this.allPreferences = this.preferences;
    }
  },

  methods: {
    getMyPreferences() {
      this.myPreferencesLoading = true;

      this.$apollo
        .mutate({
          mutation: USER_TAGS,
          variables: {
            filters: this.cacheFilters.filters
          }
        })
        .then(({ data: { userTags: { entities } } }) => {
          this.allPreferences = entities;
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.myPreferencesLoading = false;
        });
    },

    hideModal() {
      this.$refs.modalMyPreferences.hide();
      this.isShowFilters = !this.isShowFilters;
    },

    sendFilters() {
      this.getMyPreferences();

      this.$store.commit("setFilters", this.cacheFilters);
      this.hideModal();
    },

    updateSearchParams(data) {
      let filterIndex = this.cacheFilters.filters.findIndex(
        f => f.tagId == data.tagId
      );

      if (filterIndex >= 0) {
        this.$set(this.cacheFilters.filters, filterIndex, data);
      } else {
        this.cacheFilters.filters.push(data);
      }
    }
  },

  watch: {
    $route() {
      this.isShowAllPreferences = false;
    }
  },

  components: {
    FilterField,
    LoadingIcon
  }
};
